import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle1" }, " Deleting a client deletes all data associated with the client, including their posts. ", -1)
const _hoisted_2 = { class: "text-subtitle1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Confirmation",
    size: "xs",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_async_btn, {
        task: _ctx.task,
        label: "Delete",
        color: "negative",
        onClick: _ctx.deleteClient
      }, null, 8, ["task", "onClick"])
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("h2", _hoisted_2, [
        _createTextVNode(" Are you sure you want to delete "),
        _createElementVNode("strong", null, _toDisplayString(_ctx.clientName), 1),
        _createTextVNode("? ")
      ])
    ]),
    _: 1
  }, 512))
}